/**
 *
 * @author Matthew Rawson @ 22/08/2018 17:16
 * @description
 * @notes
 */
import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {Row} from "react-bootstrap"

import {injectIntl} from "@irati/utils/lang/index"
import {Reference} from "@irati-web/fields/schedule"
import id from "@irati/utils/id"

import {SpacedMarkdown} from "../Edit/SpacedMarkdown"

class ReferenceSection extends PureComponent {
  static propTypes = {
    cycle: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    disabled: false
  }

  render() {
    const idNamespace = id("FrequencySection", this.props)
    const {cycle, onChange, formatMessage, disabled} = this.props
    return (
      <div id={idNamespace}>
        <SpacedMarkdown
          id={id("cycleReference", idNamespace)}
          source={formatMessage({id: "insights.wizard.step2.accordionItem.surveyName"})} />
        <Row>
          <Reference disabled={disabled} cycle={cycle} onChange={onChange} />
        </Row>
      </div>
    )
  }
}

export default injectIntl(ReferenceSection)
